module.exports = __webpack_public_path__ + "static/media/010.fb72a79a.jpg";